export default {
  buttons: {
    cancel: "CANCELLA",
    dismiss: "Chiudi",
    add_waypoint: "Aggiungi una destinazione"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  search: {
    title: "Cerca",
    placeholder: "Inserisci una località",
    enter_location: "Inserisci una località",
    help: {
      inactive: "Cerca"
    }
  },
  filters: {
    title: "Filtri",
    amenities: {
      title: "Servizi"
    },
    fuels: {
      title: "Tipi di carburante"
    }
  },
  directions: {
    title: "Pianifica itinerario",
    placeholder: {
      destination: "Inserisci una località",
      waypoint: "Inserisci una località"
    },
    route: {
      title: "Opzioni itinerario",
      avoid_tolls: "Escludi strade a pedaggio",
      avoid_highways: "Escludi autostrade",
      title_corridor: "Distanza delle stazioni di servizio dall'itinerario"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# giorno} other {# giorni}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# minuto} other {# minuti}}\
`,
    button: "Cerca"
  },
  locations: {
    title: "Località",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} da {place}"
  },
  info_window: {
    title: "Dettagli stazione di servizio",
    location_id: "Codice Punto Vendita",
    services: "Servizi",
    nearby: "Dintorni",
    opening_hours: {
      title: "Orari di apertura e chiusura",
      mon: "Lun",
      tue: "Mar",
      wed: "Merc",
      thu: "Giov",
      fri: "Ven",
      sat: "Sab",
      sun: "Dom",
      open_twentyfourhours: "Aperto 24 ore",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Ultimo aggiornamento",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Pianifica itinerario"
  },
  fuels: {
    autogas_lpg: "GPL",
    cng: "Metano",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Diesel",
    unleaded_super: "Super Senza Piombo"
  },
  amenities: {
    air_and_water: "Colonnina dell'aria",
    atm: "Sportello Bancomat",
    austrian_highway_sticker: "Vignetta per autostrade austriache",
    bank_note_acceptor: "Deposito contante",
    cafe: "Bar",
    carwash: "Autolavaggio",
    clubsmart_card: "Carta Shell ClubSmart",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners Club",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "Carta di credito",
    czech_highway_sticker: "Vignetta per autostrade ceche",
    euroshell_card: "euroShell Card",
    fleet_card_dkv: "DKV",
    fleet_card_eni: "Multicard Eni",
    fleet_card_esso: "Esso Card",
    fleet_card_general: "euroShell Card",
    fleet_card_uta: "UTA",
    food_offerings: "Prodotti alimentari",
    full_service: "Servito",
    guarded_car_park: "Parcheggio custodito",
    hgv_lane: "Idoneo al trasporto pesante",
    high_speed_diesel_pump: "Pompa per diesel ad alta portata",
    hot_food: "Tavola calda",
    hungarian_highway_sticker: "Vignetta per autostrade ungheresi",
    parking_lanes: "Parcheggio",
    partner_loyalty_accepted: "Carte fedeltà partner accettate",
    pay_at_pump: "Pagamento alla pompa",
    quick_lubes: "Cambio olio rapido",
    restaurant: "Ristorante",
    self_service: "Self",
    service_bay: "Officina",
    shell_card: "euroShell Card",
    shop: "Negozio",
    shower: "Doccia",
    slovak_highway_sticker: "Vignetta per autostrade slovacche",
    snack_food: "Snack e fast food",
    standard_toilet: "Bagno",
    supermarket_fuel_discount: "Sconto carburante",
    toilet: "Bagno",
    truck_parking: "Parcheggio mezzi pesanti",
    truckport: "Solo camion",
    twenty_four_hour: "24 ore",
    vacuum: "Aspiratore",
    vehicle_identity_system: "Sistema di identificazione del veicolo"
  },
  settings: {
    title: "Impostazioni",
    tooltip: "Impostazioni",
    distance_units: {
      title: "Distanza",
      km: "chilometri",
      miles: "miglia"
    },
    language: {
      title: "Lingua"
    }
  }
}
